import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDasersteComponent } from './simple-icons-daserste.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDasersteComponent ],
    exports:      [ SimpleIconsDasersteComponent ],
    bootstrap:    []
})
export class SimpleIconsDasersteModule {}
